import { Injectable } from '@angular/core';
import { Contract } from "../models/Contract";
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { ContractSchema } from '../models/ContractSchema';
import { ContractSchemaService } from './contract-scheme.service';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { combineLatest } from 'rxjs';
import { quoteRequestSelector, configurationSelector } from '@app/state/app.selectors';

@Injectable({
  providedIn: 'root'
})

export class ContractService {
    constructor(
        public configService: ConfigService,
        private httpClient: HttpClient,
        private contractSchemaService: ContractSchemaService,
        private store: Store<AppState>
    ) { }

  public async getContract(quoteRequestId: number): Promise<Contract> {
        const path = this.configService.getApiPath(`${quoteRequestId}/contract`);
        return await this.httpClient.get<Contract>(path).toPromise();
    }

  public async createContract(quoteRequestId: number, data: any, schemaId: number): Promise<Contract> {
        const path = this.configService.getApiPath(`${quoteRequestId}/contract`);
        let contractData = {
            schemaId: schemaId,
            contractData: JSON.stringify(data),
        };
        return await this.httpClient.post<Contract>(path, contractData).toPromise();
    }

  public async updateContract(quoteRequestId: number, data: any, schemaId: number): Promise<Contract> {
        const path = this.configService.getApiPath(`${quoteRequestId}/contract`);
        let contractData = {
            schemaId: schemaId,
            contractData: JSON.stringify(data)
        }
        return await this.httpClient.patch<Contract>(path, contractData).toPromise();
    }

  public async getSchema(jsonSchemaType: string): Promise<ContractSchema> {
        combineLatest([this.store.select(quoteRequestSelector), this.store.select(configurationSelector)]).subscribe(([quoteRequest, configuration]) => {
            if (configuration.supplierConfiguration.vanityName?.toLowerCase() === 'cleansky') {
                if (quoteRequest.iso?.toLowerCase() === 'ercot') {
                    jsonSchemaType = 'cleansky-ercot-' + jsonSchemaType;
                }
                else {
                    jsonSchemaType = 'cleansky-'+ jsonSchemaType;
                }
            } else {
                if (quoteRequest.iso?.toLowerCase() === 'ercot') {
                    jsonSchemaType = 'ercot-' + jsonSchemaType;
                }
                else {
                  jsonSchemaType = jsonSchemaType;
                }
            }
        });
        console.log('jsonSchemaType', jsonSchemaType);
        const path = this.configService.getApiPath(`contract-schema/${jsonSchemaType}`);
        let schema = await this.httpClient.get<ContractSchema>(path).toPromise();
        schema.id = undefined;
        schema.dgsMappingSchema = '';
        const writePath = this.configService.getApiPath(`contract-schema/`);
        let res = await this.httpClient.post<ContractSchema>(writePath, schema).toPromise();
        console.log('create schema response', res);
        return res;
    }

  public async createSchema(): Promise<ContractSchema> {
        const path = this.configService.getApiPath(`contract-schema/`);
        const schema = this.contractSchemaService.getSchema();
        let res =  await this.httpClient.post<ContractSchema>(path, schema).toPromise();
        return res;
    }
}
